import { ClueTrainer } from "./cluetrainer/ClueTrainer";
document.addEventListener("DOMContentLoaded", (e) => {
    ClueTrainer.instance().start();
});
